import { createSelector } from 'reselect';
import { getDigitalSavingsState } from './index';
import { API_CALL_STATUS, FORM_STATUS } from '../../reducers/status';

export const getPersonalDetails = createSelector(getDigitalSavingsState, (state) => state.personalDetails);

export const getIsApiStatus = createSelector(getPersonalDetails, (personalDetails) => personalDetails.apiCallStatus);
export const getQuoteId = createSelector(getPersonalDetails, (personalDetails) => personalDetails.quoteId);

export const getIsApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.apiCallStatus === API_CALL_STATUS.PENDING
);

const makeGetPersonalDetailsField = (fieldName) =>
    createSelector(getPersonalDetails, (personalDetails) => personalDetails[fieldName]);

export const getPersonalDetailsForm = makeGetPersonalDetailsField('form');

export const getPersonalDetailsId = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.personalDetailId
);

export const getPersonalDetailsFormValid = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.formStatus === FORM_STATUS.VALID
);

const makeGetFieldForm = (fieldId) => createSelector(getPersonalDetailsForm, (form) => form[fieldId]);

export const getTitleValue = makeGetFieldForm('title');
export const getFirstNameValue = makeGetFieldForm('firstName');
export const getSurnameValue = makeGetFieldForm('surname');
export const getDobValue = makeGetFieldForm('dob');
export const getEmailValue = makeGetFieldForm('email');
export const getMobileNumberValue = makeGetFieldForm('mobileNumber');
export const getIdPassportValue = makeGetFieldForm('idPassport');
export const getIdNumberValue = makeGetFieldForm('idNumber');
export const getPassportValue = makeGetFieldForm('passportNumber');
export const getKraPinNumberValue = makeGetFieldForm('kraPinNumber');
export const getGenderValue = makeGetFieldForm('gender');
export const getFullAddressValue = makeGetFieldForm('fullAddress');
export const getPostalBoxValue = makeGetFieldForm('postalBox');
export const getNationalityValue = makeGetFieldForm('nationality');
export const getSourceOfFundsValue = makeGetFieldForm('sourceOfFunds');
export const getEmployerValue = makeGetFieldForm('employerName');
export const getSalaryRangeValue = makeGetFieldForm('salaryRange');
export const getSourceOfOtherFundsValue = makeGetFieldForm('sourceOfOtherFunds');
export const getSourceOfFundsDetailsValue = makeGetFieldForm('sourceOfFundsDetails');
export const getOccupationValue = makeGetFieldForm('occupation');
export const getFundsFromLegitimateSourceValue = makeGetFieldForm('fundsFromLegitimateSource');
export const getInformationIsTrueAndCorrectValue = makeGetFieldForm('informationIsTrueAndCorrect');
export const getAcceptPrivacyNoticeValue = makeGetFieldForm('acceptPrivacyNotice');
export const getReferredValue = makeGetFieldForm('referred');
